import { createFileRoute, notFound } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { PageSeo } from './-components/page-seo';
import { audiencePageSlugs, parseAudience, parseTab } from './-components/contact/audiences';

/** Only the NGO panel's "I want to ask": a form, so it has to be linkable and survive a reload. */
export const Route = createFileRoute('/www/contact/$audience/$tab')({
	// A 404, not a fallback to the default tab: anything else is the soft 404 `/new/$` exists to avoid.
	beforeLoad: ({ params }) => {
		if (!parseTab(parseAudience(params.audience), params.tab)) throw notFound();
	},
	component: Component,
});

function Component() {
	const { t } = useLingui();
	const { audience, tab } = Route.useParams();
	const parsedAudience = parseAudience(audience);
	const parsedTab = parseTab(parsedAudience, tab);
	if (!parsedAudience || !parsedTab) return null;

	return (
		<PageSeo
			slugs={audiencePageSlugs(parsedAudience, parsedTab)}
			title={t`Ask us a question - Worldcoo`}
			description={t`Are you already collaborating with Worldcoo, or do you have a question about how our fundraising channels work? Write to us and our team will reply.`}
		/>
	);
}
